// extracted by mini-css-extract-plugin
module.exports = {"a":"about-module--a--2OT_e"};